import React from 'react';
import { MenuItem, Box } from '@mui/material';
import { useLanguage } from '../../context/LanguageContext';
import SelectField from './SelectField';

const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'he', label: 'עברית', flag: '🇮🇱' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
];

const LanguageSelector = ({ variant = 'outlined', size = 'small', sx = {}, value, onChange }) => {
  const { language: contextLanguage, setLanguage: setContextLanguage } = useLanguage();
  const language = value ?? contextLanguage;
  const setLanguage = onChange ?? setContextLanguage;

  return (
    <SelectField
      options={LANGUAGES.map(({ code, label }) => ({ value: code, label }))}
      value={language}
      onChange={(v) => setLanguage(v)}
      size={size}
      sx={{ minWidth: 130, ...sx }}
      variant={variant}
      emptyLabel=""
      renderValue={(value) => {
        const lang = LANGUAGES.find((l) => l.code === value);
        return lang ? (
          <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{lang.flag}</span>
            <span>{lang.label}</span>
          </Box>
        ) : value;
      }}
    >
      {LANGUAGES.map(({ code, label, flag }) => (
        <MenuItem key={code} value={code}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{flag}</span>
            <span>{label}</span>
          </Box>
        </MenuItem>
      ))}
    </SelectField>
  );
};

export default LanguageSelector;
export { LANGUAGES };
